import React, { Fragment, useState } from "react";
// import Comments from "../Comments";
import Rate from "../Rate";
import Time from "../Time";
import { webTemp } from "../../../../../Utils/styles";
import Mobile2 from "../../../../Common/Mobile2";
import Loading from "../../../../Common/Loading";
import Looklikeitem from "../LikeItems";

import SingleItems from "./SingleItems";

export const Tab = ({
  Item,
  paranetItems,
  ItemAvgScore,
  timeTable,
  details,
  timetableRef,
  loading,
  looklikeitem,
}) => {
  if (loading) {
    return (
      <div style={{ ...webTemp }}>
        <Loading count={1} col={12} height={500} />
      </div>
    );
  }
  return (
    <Fragment>
      <div style={{ ...webTemp }} className={"mb-2 " + (window.screen.width < 768 && "px-2")}>
        <Time item={Item} timeTable={timeTable} timetableRef={timetableRef} />
        <SingleItems Item={Item} paranetItems={paranetItems} details={details} />
      </div>

      <Mobile2 />

      <div style={{ ...webTemp }} className="mb-5">
        <Looklikeitem single={true} data={looklikeitem} />
      </div>
    </Fragment>
  );
};
